import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"

import { Container, Row, Col } from "ui-Grid"
import ServiceCard from "./ServiceCard"

const styleSheet = theme => ({
  root: {
    padding: [theme.spacing.unit * 2, 0, theme.spacing.unit * 4],
    background: theme.palette.background.paper,

    [theme.breakpoints.up("sm")]: {
      padding: [theme.spacing.unit * 6, 0, theme.spacing.unit * 4],
    },
  },
})

function Services({ classes }) {
  return (
    <div className={classes.root}>
      <Container wide>
        <Row spacing={24}>
          <Col xs={12} sm={4}>
            <ServiceCard
              to="/breastfeeding-support/in-home-consultation"
              title="In Home Consultation"
              linkLabel="Get Help Breastfeeding"
              image={require("../../../../static/images/breastfeeding-card-hero.jpg")}
            >
              You may feel you lack milk, have pain when nursing, difficulty latching, limited
              weight gain or face other challenges; I can help.
            </ServiceCard>
          </Col>
          <Col xs={12} sm={4}>
            <ServiceCard
              to="/breastfeeding-support/prenatal-consultation"
              title="In Home Prenatal Consultation"
              linkLabel="Prenatal Options"
              image={require("../../../../static/images/prenatal-card-hero.jpg")}
            >
              For mothers and their partners that have questions about breastfeeding or a history of
              complications when breastfeeding
            </ServiceCard>
          </Col>
          <Col xs={12} sm={4}>
            <ServiceCard
              to="/breastfeeding-support/weight-check"
              title="Weight Check"
              linkLabel="Weight Check Details"
              image={require("../../../../static/images/weight-check-card-hero.jpg")}
            >
              This is a 5-10 minute in home visit to weigh your little one.
            </ServiceCard>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default withStyles(styleSheet)(Services)



// WEBPACK FOOTER //
// ./src/views/pages/Landing/Services.js